export default {
        "getI18nContent": {
            "i18nContentImage": [
                {
                    "image": {
                        "mimeType": "application/pdf",
                        "title": "Acceptable Use Policy Global",
                        "url": "//assets.ctfassets.net/o9ep2zekvg13/3eKjMYThE9EWldffnI9msJ/8fc968032d4961464adb9afd6393fdf3/_2022.09.16__Acceptable_Use_Policy__Global_.pdf",
                        "__typename": "ContentImage"
                    },
                    "key": "KYB_INDUSTRY_ALERT_ACCEPTABLE_USE_POLICY_GLOBAL",
                    "__typename": "I18nContentImage"
                },
                {
                    "image": {
                        "mimeType": "image/png",
                        "title": "contactless-google-pay",
                        "url": "//images.ctfassets.net/o9ep2zekvg13/rewmXoRUXOPsrrIdIe334/246b6609c58a8ea9e652132b50e5ad47/google-pay-symbol.png",
                        "__typename": "ContentImage"
                    },
                    "key": "kyb image 2",
                    "__typename": "I18nContentImage"
                },
                {
                    "image": {
                        "mimeType": "image/png",
                        "title": "Screen Shot 2022-07-20 at 10.12.12",
                        "url": "//images.ctfassets.net/o9ep2zekvg13/2fWJWZUATAQpl3eLPf5Hge/6f0d0e6cb66e1bceb80f066b91a594de/Screen_Shot_2022-07-20_at_18.39.26.png",
                        "__typename": "ContentImage"
                    },
                    "key": "kyb image 1",
                    "__typename": "I18nContentImage"
                }
            ],
            "i18nContentLabel": [
                {
                    "key": "KYB_ADDRESS_LINE_PLACEHOLDER_AUTOCOMPLETE",
                    "label": "查找地点",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ADDRESS_LINE_PLACEHOLDER",
                    "label": "详细街道地址",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_WS_DESC",
                    "label": "您的申请仍在审核中。审核流程通过需要1-2个工作日。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_KYC_IN_REVIEW_DESC_EMBEDDED",
                    "label": "一旦您的帐户通过审核，我们将处理您的此项申请。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_KYC_IN_REVIEW_DESC",
                    "label": "一旦您的帐户通过审核，我们将处理您的此项申请。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_SUBTITLE",
                    "label": "审核流程通常需要1-2个工作日。如您有疑问，请随时联系我们。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_BUTTON_TEXT",
                    "label": "上传文件",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REMOVE_ATTACHMENT_YES",
                    "label": "是，移除文件",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REMOVE_ATTACHMENT_NO",
                    "label": "不，返回",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELETE_FILE_CONFIRMATION",
                    "label": "确定移除文件？",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELETE_FILE_CONFIRMATION_DETAILED",
                    "label": "您确定要移除文件？",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_PREVIEW",
                    "label": "文件预览",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_ERROR",
                    "label": "我们无法上传您的文件",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DRAG_FILE_INVALID",
                    "label": "文件类型不支持",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DRAG_TOO_MANY_FILES",
                    "label": "文件数量超出限制",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_CLOSE",
                    "label": "关闭",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_DOWNLOAD",
                    "label": "下载",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_DOWNLOAD_CTA",
                    "label": "若您需要查看此文档，请在下面下载",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_UNABLE_TO_PREVIEW",
                    "label": "您无法预览此文档",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_NO_PREVIEW",
                    "label": "不支持预览",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_ERROR_FILE_BROKEN",
                    "label": "获取文件出错",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_VIEW",
                    "label": "预览",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_REMOVE",
                    "label": "移除",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPLOAD_CTA_ADD",
                    "label": "选择文件",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DROPZONE_UPLOAD_PROMPT",
                    "label": "将您的文件拖至此处，或",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_MAX_LENGTH_256",
                    "label": "长度不能超过256个字符。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_MAX_LENGTH_1024",
                    "label": "长度不能超过1024个字符。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ATTACHMENT_MODAL_HEADING",
                    "label": "文件上传",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_CLOSE_LABEL",
                    "label": "关闭",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DOWNLOAD_LABEL",
                    "label": "下载",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PLEASE_DOWNLOAD_FILE",
                    "label": "若您需要查看此文档，请在点击下方下载",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_CANNOT_PREVIEW_FILE",
                    "label": "您无法预览此文档",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_ALERT_NOT_SUPPORTED_BY_AMEX",
                    "label": "美国运通卡暂不支持该行业。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NO_AVAILABLE_PAYMENT_METHODS_ERROR",
                    "label": "缺少可用的支付方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REJECT_DESC_EMBEDDED",
                    "label": "我们无法继续推进您的本次申请。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_DIALOG_BUTTON",
                    "label": "完成",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_ALERT_RESTRICTED_EMBEDDED",
                    "label": "{{brandName}}当前可能无法为该行业的某些客户提供服务。为确保您的申请能够顺利处理，请尽可能多的提供有关您的业务的详细信息。如果您想详细了解 {{brandName}} 目前可以提供服务的行业，请查看我们的[政策](download://KYB_INDUSTRY_ALERT_ACCEPTABLE_USE_POLICY_GLOBAL)或联系[客户支持]({{contactUsUrl}})。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_ALERT_PROHIBITED_EMBEDDED",
                    "label": "很抱歉，我们不支持为该行业的大多数客户提供服务。您的申请可能会被拒绝。如果您想详细了解 {{brandName}} 目前可以提供服务的行业，请查看我们的[政策](download://KYB_INDUSTRY_ALERT_ACCEPTABLE_USE_POLICY_GLOBAL)或联系[客户支持]({{contactUsUrl}})。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STEP_2_DESC_EMBEDDED",
                    "label": "当您的申请通过后，我们可能会提供多个保证金方案供您选择。\n\n一些支付方式将实时激活供您使用，其余部分可能需要更多的等待时间。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_DESC_ONLY_ONE_RESERVE_OPTION_EMBEDDED",
                    "label": "根据您所提交的材料，我们为您提供以下保证金方案供您选择。请注意您所选择的方案未来有可能根据您的实际交易活动而调整。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_ALERT_AUTO_ACCEPTED_EMBEDDED",
                    "label": "根据您提交的材料，您的保证金方案已优化。请您查看更新的保证金方案。如有任何疑问，请[联系我们]({{contactUsUrl}})。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REJECT_MANUAL_DESC_EMBEDDED",
                    "label": "我们无法继续推进您的本次申请。\n\n如您有疑问，请随时与我们取得联系。[联系我们]({{contactUsUrl}})",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_DESC_EMBEDDED",
                    "label": "根据您所提交的材料，我们为您提供以下保证金方案供您选择。请注意您所选择的方案未来有可能根据您的实际交易活动而调整。如果您未来想改变方案类型，请与我们联系。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_FOR_ONGOING_CASE",
                    "label": "- __{{paymentMethods}}__ 需要提供您的客户在线结帐的网站或应用程序。\n- 您可以在有网站或应用程序后再回来，或者您可以先激活不需要它的支付方式。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_DESC_ONLY_ONE_RESERVE_OPTION",
                    "label": "根据您所提交的材料，我们为您提供以下保证金方案供您选择。请注意您所选择的方案未来有可能根据您的实际交易活动而调整。\n\n了解更多关于[保证金方案](https://www.payloco.com/docs/online-payments__reserve-plan)与[标准结算时间](https://www.payloco.com/docs/online-payments__overview)的信息。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_MIXED_DESC",
                    "label": "__{{firstSettlementPercentage}}% 的资金__ 将在交易发生 __{{firstSettlementDelay}} 天__ 后结算，余下 __{{secondSettlementPercentage}}%__ 将在交易发生的 __{{secondSettlementDelay}}天__ 后结算",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DUPLICATE_PAYMENT_METHODS_ERROR_PLURAL",
                    "label": "{{paymentMethods}}正在激活中",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DUPLICATE_PAYMENT_METHODS_ERROR_SINGULAR",
                    "label": "{{paymentMethods}}正在激活中",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NETWORK_ERROR",
                    "label": "网络出错了，请稍候重试",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_CARDS_ALERT",
                    "label": "请至少选择一种银行卡支付方式，因为没有银行卡无法激活 Google Pay 或 Apple Pay。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ONGOING_MODAL_BUTTON",
                    "label": "知道了",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ONGOING_MODAL_BODY_WEBSITE_REQUIRED",
                    "label": "激活支付方式将占用您 2 分钟时间。大多数申请会**立刻**获得批准，但有些申请可能需要 2 个工作日。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ONGOING_MODAL_TITLE",
                    "label": "激活新的支付方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_DESCRIPTION",
                    "label": "请提供您的客户使用新的支付方式下订单和支付的网站或应用程序。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACTIVATE_NEW_PAYMENT_METHODS",
                    "label": "激活新的付款方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE",
                    "label": "网址",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_UPDATED_INFORMATION",
                    "label": "信息变更",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMENT_METHODS",
                    "label": "支付方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_DESC",
                    "label": "根据您所提交的材料，我们为您提供以下保证金方案供您选择。请注意您所选择的方案未来有可能根据您的实际交易活动而调整。如果您未来想改变方案类型，请与我们联系。\n\n了解更多关于[保证金方案](https://www.payloco.com/docs/online-payments__reserve-plan)与[标准结算时间](https://www.payloco.com/docs/online-payments__overview)的信息。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_TITLE_ONLY_ONE_RESERVE_OPTION",
                    "label": "您的申请已通过！请确认保证金方案。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_MIXED_TITLE",
                    "label": "混合保证金",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_BANK_DIRECT_DEBIT",
                    "label": "Bank direct debit",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_AVG_TXN_HIGHEST_ALERT",
                    "label": "您的平均交易规模明显高于大多数商家。请确保交易规模准确反映您的商业模式。我们可能会在审查时要求您提供更详细的证据来支持更大的交易规模。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_MAX_TXN_EQUAL_ALERT",
                    "label": "您的最大交易规模等于您的平均交易规模，这意味着您的所有订单都是相同的交易规模。请确保这准确反映了您的业务模式。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_MAX_TXN_HIGHEST_ALERT",
                    "label": "您的平均交易规模明显高于大多数商家。请确保交易规模准确反映您的商业模式。我们可能会在审查时要求您提供更详细的证据来支持更大的交易规模。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IMPLIED_MON_TXN_ALERT",
                    "label": "您的交易规模和交易量表明您预计每月大约仅有 10 笔交易。这低于大多数商家。请确保所列数字准确反映了您现阶段的预期交易量。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_MAX_TXN_HIGHER_ALERT",
                    "label": "您的最大交易规模高于大多数商家，请确保交易规模准确反映您的商业模式。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_AVG_TXN_HIGHER_ALERT",
                    "label": "您的平均交易规模高于大多数商家，请确保交易规模准确反映您的商业模式。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_HINT_FOR_PM_URL_REQUIRED",
                    "label": "您选择的[支付方式](https://www.payloco.com/docs/online-payments__overview)中有一种或多种需要提供网址。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_URL_REQUIRED_ALERT",
                    "label": "您选择的支付方式中有一种或多种需要提供网址。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_AVG_TXN_LESS_THAN_MAX_TXN",
                    "label": "单笔平均交易规模应等于或小于单笔最大交易规模",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_MAX_TXN_GREAT_THAN_MON_TXN",
                    "label": "单笔最大交易规模应等于或小于平均月交易额",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_MAX_TXN_LESS_THAN_AVG_TXN",
                    "label": "单笔最大交易规模应大于或等于单笔平均交易规模",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_MON_VAL_LESS_THAN_MAX_TXN",
                    "label": "平均月交易额应大于或等于单笔最大交易规模",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_ALERT_AUTO_ACCEPTED",
                    "label": "根据您提交的材料，您的保证金方案已优化。请您查看更新的保证金方案。如有任何疑问，请[联系我们](mailto:underwriting@payloco.com)。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAGE_INTRO_DESC_GLOBAL",
                    "label": "仅需10分钟，您便可激活{{platform}}收单产品。如您中途离开，您所填写的内容将自动保存。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAGE_INTRO_TITLE_GLOBAL",
                    "label": "{{platform}}收单产品",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_ALERT_PROHIBITED",
                    "label": "很抱歉，我们不支持为该行业的大多数客户提供服务。您的申请可能会被拒绝。如果您想详细了解 PayLoco 目前可以提供服务的行业，请查看我们的[政策](download://KYB_INDUSTRY_ALERT_ACCEPTABLE_USE_POLICY_GLOBAL)或联系[客户支持](https://help.payloco.com/hc/zh-cn/requests/new)。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_ALERT_RESTRICTED",
                    "label": "Airwallex当前可能无法为该行业的某些客户提供服务。为确保您的申请能够顺利处理，请尽可能多的提供有关您的业务的详细信息。如果您想详细了解 PayLoco 目前可以提供服务的行业，请查看我们的[政策](download://KYB_INDUSTRY_ALERT_ACCEPTABLE_USE_POLICY_GLOBAL)或联系[客户支持](https://help.payloco.com/hc/zh-cn/requests/new)。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_RESERVE_NOTE_GLOBAL",
                    "label": "请注意，此项保证金方案未来在以下情况下可能发生调整：\n\n- 实际交易活动与本次申请提交的材料存在差异\n- 在此帐户中增加新的支付方式\n- 使用此帐户的公司主体开设其他帐户并激活收单",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_DESC",
                    "label": "请选择以下一个或多个选项。基于您的选择，我们将展示您可以使用的收单产品以及其支持的支付方式。[了解关于收单产品与支付方式的更多信息。](https://www.payloco.com/docs/online-payments__starting-with-payments)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_ONLINE_PAYMENTS_TOOLTIP",
                    "label": "[__点击此处__](https://www.payloco.com/docs/online-payments__overview)了解哪些在线收单的对接方式可支持此支付方式。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_DISPUTE_DESC",
                    "label": "告知我们您过去**三个月**的平均拒付率与退款率。请尽量精确填写。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_VOLUME_DESC",
                    "label": "请告知我们您的预计交易额按照以下支付方式占比分布情况。请尽量精确填写。占比加总应**等于100%**。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_OPTION_BEFORE",
                    "label": "我在我的客户支付订单**之前**便已交付产品或服务。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_DESC",
                    "label": "请提供在**未来12个月**内您预计与 {{platform}}合作产生的交易规模与交易额。如果您没有有效的历史交易数据，请尝试估计相应数字。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_CUR_HINT",
                    "label": "数字以**{{currency}}**计价。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_DESC",
                    "label": "您的业务场景：__{{businessScenarios}}__\n\n- 您可使用的收单产品：{{paymentProducts}}\n\n- 收单产品所支持的支付方式列示如下。[了解关于支付方式的更多信息。](https://www.payloco.com/docs/online-payments__overview)\n\n请选择您需要的支付方式。未来如果您想增加更多支付方式，请联系我们。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_FOOTER_HINT",
                    "label": "不确定选择哪个选项？[点击此处寻求帮助。](https://www.payloco.com/docs/online-payments__starting-with-payments#supported-operating-models)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_AWX_APPLE_AND_GOOGLE",
                    "label": "我同意{{onlineTerms}}，[Apple Pay](https://developer.apple.com/apple-pay/acceptable-use-guidelines-for-websites/)，[Google Pay](https://payments.developers.google.com/terms/sellertos)的条款与政策。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_AWX_AND_GOOGLE",
                    "label": "我同意{{onlineTerms}}，[Google Pay](https://payments.developers.google.com/terms/sellertos)的条款与政策。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_ONLINE_NL",
                    "label": "[在线收单](https://www.payloco.com/eu/nl/terms#online-payments-terms)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_ONLINE_HK",
                    "label": "[在线收单](https://www.payloco.com/hk/terms/online-payment-terms)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_ONLINE_AU",
                    "label": "[在线收单](https://www.payloco.com/au/terms/online-payment-terms)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_ONLINE_SG",
                    "label": "[在线收单](https://www.payloco.com/sg/terms/online-payment-terms)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_ONLINE_UK",
                    "label": "[在线收单](https://www.payloco.com/hk/terms/online-payment-terms)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_NO_RESERVE_DESC",
                    "label": "根据您目前的情况，我们暂时不需要您提供保证金。您的所有资金将在[标准结算时间](https://www.payloco.com/docs/online-payments__overview)内结算至您的帐户内。请注意，未来可能根据您的实际交易活动，我们仍有可能要求您提供保证金。了解更多关于[保证金方案](https://www.payloco.com/docs/online-payments__reserve-plan)的信息。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_ROLLING_2_DESC",
                    "label": "__{{rate}}% 的资金__ 将在交易发生的 __{{days}} 天__ 后结算，其他资金将在交易发生的2-3天后结算",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_ROLLING_DESC",
                    "label": "__{{rate}}% 的资金__ 将在交易发生的 __{{days}} 天__ 后结算，其他资金将在交易发生的2-3天后结算",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_ROLLING_2_TITLE",
                    "label": "滚动保证金 - 较低的锁定金额",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_ROLLV_TITLE",
                    "label": "滚动保证金 - 较低的锁定金额",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_ROLLING_TITLE",
                    "label": "滚动保证金 - 较短的锁定期限",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_AWX_ONLY",
                    "label": "我同意{{onlineTerms}}的条款与政策。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_HINT_OPTIONAL",
                    "label": "如果您未提交网站网址，某些[支付方式](https://www.payloco.com/docs/online-payments__overview)将无法使用。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVED_PHRASE",
                    "label": "您的申请已通过！",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_REJECT_SUB",
                    "label": "以下您申请的支付方式无法被激活。[为什么支付方式无法被激活？](https://www.payloco.com/docs/online-payments__acceptable-uses-and-scheme-restrictions)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REJECT_MANUAL_DESC",
                    "label": "我们无法继续推进您的本次申请。[为什么我们无法推进？](https://www.payloco.com/docs/online-payments__acceptable-uses-and-scheme-restrictions)\n\n如您有疑问，请随时与我们取得联系。[联系我们](mailto:underwriting@airwallex.com)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REJECT_DESC",
                    "label": "我们无法继续推进您的本次申请。[为什么我们无法推进？](https://www.payloco.com/docs/online-payments__acceptable-uses-and-scheme-restrictions)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_ALERT_INFO",
                    "label": "一旦您具备已上线的网站或移动应用程序，您可以回到此页面继续申请。与此同时，您可以申请PayLoco测试帐户体验我们的收单产品能力。[申请测试帐户](https://help.payloco.com/hc/zh-cn/requests/new)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_XERO_INVOICE_LINK",
                    "label": "[Xero Invoice收单](https://www.payloco.com/docs/online-payments__starting-with-payments__invoice-integrations)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_PAYMENT_LINK_LINK",
                    "label": "[收款链接](https://www.payloco.com/docs/online-payments__starting-with-payments__payment-links)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_ONLINE_PAYMENTS_LINK",
                    "label": "[在线收单](https://www.payloco.com/docs/online-payments__starting-with-payments__online-payments)",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STEP_2_DESC",
                    "label": "当您的申请通过后，我们可能会提供多个[保证金方案](https://www.payloco.com/docs/online-payments__reserve-plan)供您选择。\n\n一些[支付方式](https://www.payloco.com/docs/online-payments__overview)将实时激活供您使用，其余部分可能需要更多的等待时间。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_SHOULD_BE_ASCII",
                    "label": "输入值应为只包含ASCII字符, 0-9以及,.:/+-~·[]",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_XERO_INVOICE",
                    "label": "Xero Invoice收单",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_SUM_SHOULD_100",
                    "label": "百分比之和应等于100%",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NAV_ACTIVATE_PAYMENT",
                    "label": "激活支付方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TERMS_AWX_AND_APPLE",
                    "label": "我同意{{onlineTerms}}，[Apple Pay](https://developer.apple.com/apple-pay/acceptable-use-guidelines-for-websites/)的条款与政策。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_REQUIRED",
                    "label": "必填",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_EXCEED_MAX",
                    "label": "输入值不应超过 {{max}}",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_SHOULD_BE_NUMBER",
                    "label": "输入值应为数字",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_EXCEED_MIN",
                    "label": "输入值不应小于 {{min}}",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_SHOULD_BE_INTEGER",
                    "label": "输入值应为整数",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_SHOULD_BE_POSITIVE",
                    "label": "输入值应为正数",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ERR_INVALID_TYPE",
                    "label": "数据类型错误",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAGE_INTRO_DESC",
                    "label": "仅需10分钟，您便可激活PayLoco收单产品。如您中途离开，您所填写的内容将自动保存。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAGE_INTRO_TITLE",
                    "label": "PayLoco收单产品",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_REJECT_TITLE",
                    "label": "激活失败的支付方式（{{number}}）",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NEXT",
                    "label": "Next",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_ALERT_H",
                    "label": "PayLoco can't support companies in this category. You cannot proceed with the industry selected.",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_ALERT_L",
                    "label": "PayLoco can't support most businesses in this category. Once you submit your application, we'll review it to learn whether we can support your specific business.",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NO_OPTIONS_MESSAGE",
                    "label": "没有选项",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_OPTION_EXACT_SUFFIX",
                    "label": "days",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_ALERT_INFO_PBA",
                    "label": "You can come back later when you have a live website or app.",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_ONLINE_BANKING",
                    "label": "Online banking",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_BNPL",
                    "label": "BNPL",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PLATFORM_AIRWALLEX",
                    "label": "PayLoco",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_SHOW_MORE",
                    "label": "Show more",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_SHOW_LESS",
                    "label": "Show less",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_CARDS_APPLEPAY_GOOGLEPAY",
                    "label": "Cards, Apple Pay, Google Pay",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STEP_1_TITLE",
                    "label": "产品申请",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STEP_1",
                    "label": "第一步",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STEP_2",
                    "label": "第二步",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STEP_2_TITLE",
                    "label": "产品激活",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BUTTON_NEXT",
                    "label": "下一步",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_TITLE",
                    "label": "您的客户通常是如何支付订单的？",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_OTHERS_TITLE",
                    "label": "账单支付或自定义支付链接",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_PHYSICAL_TITLE",
                    "label": "面对面支付",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_ONLINE_TITLE",
                    "label": "在线支付（网页端或移动端）",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_PHYSICAL_DESC",
                    "label": "我们的客户通过在我们的电子设备上输入支付信息或扫描二维码支付订单（POS机支付除外）。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_OTHERS_DESC",
                    "label": "我们的客户在收到的账单或自定义支付链接上支付订单。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_TITLE",
                    "label": "选择支付方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_SEARCH_PLACEHOLDER",
                    "label": "搜索支付方式名称",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_COLUMN_ACT_TIME_TITLE",
                    "label": "激活时间",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_COLUMN_LOCATION_TITLE",
                    "label": "消费者地区",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_COLUMN_TYPE_TITLE",
                    "label": "类型",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_COLUMN_PAYMETH_TITLE",
                    "label": "支付方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_METHOD_TYPE_PLACEHOLDER",
                    "label": "支付方式类型",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_LOCATION_PLACEHOLDER",
                    "label": "消费者地区",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TASKFLOW_TITLE",
                    "label": "激活收单产品",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_METHOD_TYPE_SELECT_ALL",
                    "label": "选择所有类型",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_COLUMN_ACT_TIME_PLURAL",
                    "label": "个工作日",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_COLUMN_ACT_TIME_SINGULAR",
                    "label": "个工作日",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_COLUMN_ACT_TIME_ZERO",
                    "label": "实时激活",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_LOCATION_SELECT_ALL",
                    "label": "选择所有地区",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_PRODUCT_TYPE_PLACEHOLDER",
                    "label": "产品类型",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_PM_DESC_PREFIX",
                    "label": "收单产品：",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_PRODUCT_TYPE_SELECT_ALL",
                    "label": "选择所有类型",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BUTTON_BACK",
                    "label": "上一步",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BASIC_INFO_TITLE",
                    "label": "基本信息",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BASIC_INFO_STORE_DESC",
                    "label": "请描述您提供的产品或服务。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BASIC_INFO_DESC",
                    "label": "请填写关于您业务的基本信息。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TRADING_NAME",
                    "label": "交易名称",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TRADING_NAME_HINT",
                    "label": "此名称通常出现在您消费者的收据凭证上。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_TITLE",
                    "label": "网站网址",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_HINT",
                    "label": "如果您的消费者在移动端支付订单，请输入您的移动端应用程序在应用商店的相关链接",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STORE_ONLINE_DESC",
                    "label": "我们的客户通常在我们开设的网站或移动端应用程序上进行下单并线上支付订单",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_WEBSITE_CHECKBOX_LABEL",
                    "label": "暂无已上线的网站或移动端应用程序",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_TITLE",
                    "label": "行业",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INDUSTRY_HINT",
                    "label": "选择描述您业务最为恰当的行业。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_TITLE",
                    "label": "交易信息",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_MAX_TXN_SIZE",
                    "label": "单笔最大交易规模",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_AVG_TXN_SIZE",
                    "label": "单笔平均交易规模",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_AVG_MONTH_VOL",
                    "label": "平均月交易额",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_CBT_PER",
                    "label": "向国际客户提供的产品或服务交易额占比",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DIALOG_CHANGE_CUR_HEADING",
                    "label": "更换币种",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DIALOG_CHANGE_CUR_CONTENT",
                    "label": "您可以将默认币种更换为您偏好的任意币种。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BUTTON_CANCEL",
                    "label": "取消",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BUTTON_DONE",
                    "label": "完成",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_TITLE",
                    "label": "交付时间",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_DESC",
                    "label": "请告知我们您的客户在下单支付完成后，通常需要等待多久收到他们的产品或服务。请尽量精确填写。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_OPTION_EXACT",
                    "label": "我能提供精准数值：",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_OPTION_RANGE",
                    "label": "我能提供大致时间范围：",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_MORE_THAN",
                    "label": "超过",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_MONTH",
                    "label": "个月",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_DAYS",
                    "label": "天",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_QUESTION",
                    "label": "针对这项业务，您目前正在使用收单产品吗？",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_QUESTION_YES",
                    "label": "是",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_QUESTION_NO",
                    "label": "否",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_VOLUME_TITLE",
                    "label": "交易额按支付方式占比分布",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_SEE_ALL",
                    "label": "查看更多",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_DISPUTE_TITLE",
                    "label": "拒付与退款",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_DISPUTE_LABEL",
                    "label": "拒付率",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_REFUND_LABEL",
                    "label": "退款率",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_TITLE",
                    "label": "检查您的申请信息",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_DESC",
                    "label": "请在提交前检查您所填写的以下申请信息。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_PAYMENT_SOLUTION",
                    "label": "收单解决方案",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_PAYMENT_SCENARIO",
                    "label": "业务场景",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_PAYMENT_PRODUCT",
                    "label": "收单产品",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_PAYMENT_METHOD",
                    "label": "支付方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_SHOW_MORE",
                    "label": "显示更多",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_SHOW_LESS",
                    "label": "收起",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_BUSINESS_DETAILS",
                    "label": "业务信息",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_CBT_SHIPPING",
                    "label": "国际客户交易额占比",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BUTTON_SUBMIT",
                    "label": "提交",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ADDRESS_TITLE",
                    "label": "主要线下交易地址",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ADDRESS_COUNTRY_LABEL",
                    "label": "国家或地区",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_STEP_1_DESC",
                    "label": "为您的业务选择合适的收单解决方案，同时填写一些必要信息。\n\n大部分申请将 __实时__ 审批通过。如果您的申请没有实时通过，我们将于 __1-2__ 个工作日后与您取得联系。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ADDRESS_STREET_LABEL",
                    "label": "街道地址",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ADDRESS_CITY_LABEL",
                    "label": "城市",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ADDRESS_STATE_LABEL",
                    "label": "州/省市自治区",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ADDRESS_ZIPCODE_LABEL",
                    "label": "邮政编码",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_OPTIONAL",
                    "label": "选填",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMENT_TYPE_DISTRIBUTION_C",
                    "label": "其他支付方式",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_REFUND_TOOLTIP",
                    "label": "退款率指您向您的客户退款总金额占所有成功交易金额的百分比。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAOP_DISPUTE_TOOLTIP",
                    "label": "拒付率指您的所有交易中，被卡组织标记为拒付的总交易额占所有成功交易额的百分比。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REQUIRED",
                    "label": "必填",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REVIEW_STORE_DESC",
                    "label": "产品或服务描述",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_CARDS",
                    "label": "银行卡",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_WALLET",
                    "label": "钱包",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_ONLINE_BANKING_REDIRECT",
                    "label": "网上银行跳转",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_CRYPTOCURRENCY",
                    "label": "加密货币",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_CASH",
                    "label": "现金或ATM支付",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_BANK_TRANSFER",
                    "label": "银行转账",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_ONLINE_PAYMENTS",
                    "label": "在线收单",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_PAYMENT_LINK",
                    "label": "收款链接",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_TAG_POPULAR",
                    "label": "热门",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_DELIVERY_INSTANT",
                    "label": "实时收到",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMENT_TYPE_DISTRIBUTION_B",
                    "label": "银行借记",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMENT_TYPE_DISTRIBUTION_B_REVIEW",
                    "label": "银行借记：{{percentage}}% ",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMENT_TYPE_DISTRIBUTION_A_REVIEW",
                    "label": "银行卡，Apple Pay, Google Pay: {{percentage}}% ",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMENT_TYPE_DISTRIBUTION_C_REVIEW",
                    "label": "其他支付方式：{{percentage}}% ",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_CBT_PER_TOOLTIP",
                    "label": "国际客户指您客户所在国家或地区与您的业务所在国家或地区不同的客户群体。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMENT_TYPE_DISTRIBUTION_A",
                    "label": "银行卡，Apple Pay，Google Pay",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_METHOD_TYPE_ALL_PREFIX",
                    "label": "所有",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_METHOD_TYPE_PLURAL",
                    "label": "类型",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_LOCATION_PLURAL",
                    "label": "地区",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_PRODUCT_TYPE_PLURAL",
                    "label": "产品类型",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_PRODUCT_TYPE_ALL_PREFIX",
                    "label": "所有",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PAYMETH_LOCATION_ALL_PREFIX",
                    "label": "所有",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_PM_GLOBAL",
                    "label": "全球",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_INVALID_URL_ERROR",
                    "label": "请输入有效网址",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_TXN_INFO_CUR_CHANGE_CUR",
                    "label": "更换币种",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NAV_APPLICATION",
                    "label": "产品申请",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NAV_CHOOSE_PAYMENT",
                    "label": "选择收单解决方案",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NAV_BUS_INFO",
                    "label": "提供业务信息",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NAV_REVIEW",
                    "label": "检查与提交申请",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NAV_ACTIVATION",
                    "label": "产品激活",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_NAV_SELECT_RESERVE",
                    "label": "选择保证金方案",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_SELECT_LABEL",
                    "label": "选择...",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_KYC_IN_REVIEW_TITLE",
                    "label": "您的申请正在进一步审核中",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_TITLE",
                    "label": "您的申请正在审核中",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_EXTRA_TITLE",
                    "label": "提供以下材料将加快审核流程",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_EXTRA_SUBTITLE",
                    "label": "为了加快审核流程，我们建议您提供贵公司业务最新的 __财务报告__ ：\n\n- 利润表\n- 资产负债表\n- 现金流表",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_UPLOAD_DESC",
                    "label": "请将文件置于此处",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_UPLOAD_BUTTON",
                    "label": "上传",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_UPLOAD_HINT",
                    "label": "支持的文件类型：PDF, JPG, PNG，最大不超过10MB",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_UPLOADED_TITLE",
                    "label": "已上传文件",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_UPLOAD_ERR_FAILED",
                    "label": "上传失败。请重试。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_UPLOAD_ERR_TOO_LARGE",
                    "label": "文件过大。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_UPLOAD_ING_PREFIX",
                    "label": "上传中",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_IN_REVIEW_WS_TITLE",
                    "label": "财务报告已成功提交",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BUTTON_DO_IT_LATER",
                    "label": "稍后再做",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REJECT_MANUAL_TITLE",
                    "label": "很抱歉，我们无法继续推进您的申请",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_TITLE",
                    "label": "您的申请已通过！离激活还有最后一步",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_SUBTITLE",
                    "label": "选择保证金方案",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_ALERT",
                    "label": "保证金方案将应用于以下的支付方式交易金额：\n__{{paymentMethodsList}}__",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_RETRY_ALERT",
                    "label": "保证金方案已更新。请您重新选择方案并继续。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_DELAY_TITLE",
                    "label": "延迟结算",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_ROLLP_TITLE",
                    "label": "滚动保证金 - 较短的锁定期限",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_DELAY_DESC",
                    "label": "所有资金将在交易发生的 __{{days}}__ 天后结算至您的钱包",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_BUTTON_CONFIRM",
                    "label": "确认",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_ROLLP_DESC",
                    "label": "__{{rate}}% 的资金__ 将在交易发生的 __{{days}} 天__ 后结算，其他资金将在交易发生的2-3天后结算",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_APPROVE_OPTION_ROLLV_DESC",
                    "label": "__{{rate}}% 的资金__ 将在交易发生的 __{{days}} 天__ 后结算，其他资金将在交易发生的2-3天后结算",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_TITLE",
                    "label": "支付方式正在激活中",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_ACTED_TITLE",
                    "label": "已激活的支付方式（{{number}}）",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_ACTED_SUB",
                    "label": "您即刻可开始使用以下支付方式进行收单。",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_STATUS_ACTIVATED",
                    "label": "已激活",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_STATUS_REJECTED",
                    "label": "激活失败",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_STATUS_INFO_REQUIRED",
                    "label": "补充信息",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_STATUS_IN_PROGRESS",
                    "label": "激活中",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_PENDING_TITLE",
                    "label": "正在激活的支付方式（{{number}}）",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_RESERVE_TITLE",
                    "label": "保证金方案",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_NO_RESERVE_TITLE",
                    "label": "无需保证金",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_RESERVE_SUB_PREFIX",
                    "label": "应用于",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ACT_RESERVE_NOTE",
                    "label": "请注意，此项保证金方案未来在以下情况下可能发生调整：\n\n- 实际交易活动与本次申请提交的材料存在差异\n- 在此帐户中增加新的支付方式\n- 使用此帐户的公司主体开设其他帐户并激活收单",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_REJECT_TITLE",
                    "label": "很抱歉，我们无法继续推进您的申请",
                    "__typename": "I18nContentLabel"
                },
                {
                    "key": "KYB_ALL_ACT_TITLE",
                    "label": "支付方式已激活",
                    "__typename": "I18nContentLabel"
                }
            ],
            "__typename": "I18nContent"
        }
}